import { render } from "./BillingSuppliersFormerPage.vue?vue&type=template&id=06b2c80b&ts=true"
import script from "./BillingSuppliersFormerPage.vue?vue&type=script&lang=ts"
export * from "./BillingSuppliersFormerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__